import "./app.css";
import App from "./App.svelte";
import { mount } from "svelte";

const target = document.getElementById("app");
if (!target) {
  throw new Error("Missing #app mount point");
}

mount(App, { target });

/* PWA service worker — dropped in the embedded build. The dongle has
   no internet, no offline-cache benefit (the SPA already lives on
   flash), and autoUpdate flows are confusing on hardware the user
   doesn't manage. Rollup marks `virtual:pwa-register` as external in
   the embedded build (see vite.config.ts) so this gated branch
   tree-shakes cleanly. */
if (!__EMBEDDED__) {
  void import("virtual:pwa-register").then(({ registerSW }) => {
    registerSW({
      onRegisteredSW(swUrl) {
        // eslint-disable-next-line no-console
        console.info("[tunex] service worker registered:", swUrl);
      },
    });
  });
}
